<template>
  <v-container
  pa-0
  fluid>
          <v-row
          ma-2
            >
            <v-col cols="12">
                    <mrx-translation :token="prompt"></mrx-translation>
            </v-col>     
             <v-col cols="6">
                  <v-progress-circular
                  :rotate="360"
                  :size="150"
                  :width="20"
                  :value="progress"
                  :color="color"
                  >
                   <mrx-translation :token="display"></mrx-translation>
                   {{ elapsedDisplay }}
                  </v-progress-circular>
              </v-col>
              <v-col cols="6">
                 <v-row>
                 
                  <v-col v-show="this.timer.status === 'none'">
                  <v-btn block @click="start" color="success">
                    <mrx-translation token="components.rdt.timer.btn.start"></mrx-translation>
                  </v-btn>
                  </v-col>
                  
                  <v-col  v-show="false">
                  <v-btn block @click="retake">
                    <mrx-translation token="components.rdt.timer.btn.retake" ></mrx-translation>
                  </v-btn>
                  </v-col>
                  
                  <v-col v-show="this.timer.status !== 'none'">
                  <v-btn block @click="skip">
                    <mrx-translation token="components.rdt.timer.btn.skip"></mrx-translation>
                  </v-btn>
                  </v-col>
                  
                  <v-col v-show="rdtTestMode">
                  <v-btn block @click="simulate()">
                    <mrx-translation token="components.rdt.timer.btn.simulate"></mrx-translation>
                  </v-btn>
                  </v-col>
                  
                </v-row>
              </v-col>
          </v-row>
</v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data() {
            return {
                elapsed: 0,
                interval: null,
                elapsedDisplay: null
            }
        },
        computed: {

            rdtTestMode() {
                return this.$store.getters['v4/mode/get']('rdtTestMode')
            },

            prompt() {
                return `components.rdt.timer.prompt.${this.timer.status}`
            },

            timer() {
                return this.$store.state.v4.rdt
            },

            active() {
                return this.timer.status === 'waiting' || this.timer.status === 'aquiring'
            },

            progress() {
                if (this.timer.status === 'waiting') return 100 - (this.elapsed / this.timer.aquire) * 100
                if (this.timer.status === 'aquiring') return ((this.elapsed - this.timer.aquire) / (this.timer.timeout - this.timer.aquire)) * 100
                if (this.timer.status === 'timedout') return 100
                return 100
            },

            color() {
                if (this.timer.status === 'waiting') return 'blue'
                if (this.timer.status === 'aquiring') return 'green'
                if (this.timer.status === 'timedout') return 'red'
                return 'blue'
            },

            display() {
                if (this.timer.status === 'timedout') {
                    this.elapsedDisplay = null
                    return 'components.rdt.timer.status.timedout'
                }
                else if (this.timer.status === 'captured') {
                    this.elapsedDisplay = null
                    return 'components.rdt.timer.status.captured'
                }
                else if (this.timer.status === 'none') {
                    this.elapsedDisplay = null
                    return 'components.rdt.timer.status.ready'
                }
                else if (this.timer.status === 'aquiring') {
                    let seconds = Math.floor((this.timer.timeout - this.elapsed + 1000) / 1000)
                    let minutes = Math.floor(seconds / 60)
                    seconds = seconds % 60
                    seconds = seconds < 10 ? `0${seconds}` : `${seconds}`
                    minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                    this.elapsedDisplay = `${minutes}:${seconds}`
                    return null
                }

                else if (this.timer.status === 'waiting') {
                    let seconds = Math.floor((this.timer.aquire - this.elapsed + 1000) / 1000)
                    let minutes = Math.floor(seconds / 60)
                    seconds = seconds % 60
                    seconds = seconds < 10 ? `0${seconds}` : `${seconds}`
                    minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                    this.elapsedDisplay = `${minutes}:${seconds}`
                    return null
                }

            },

        },

        mounted() {
            if (this.timer.autoStart && this.timer.status === 'none') {
                this.start()
            }

            console.log(`/track/${this.$route.params.tracks_id}/observation/?fhirBundle=eyJyZXNvdXJjZVR5cGUiOiJCdW5kbGUiLCJ0eXBlIjoiYmF0Y2giLCJlbnRyeSI6W3sicmVzb3VyY2UiOnsiY29kZSI6eyJjb2RpbmciOlt7ImNvZGUiOiJyZHRCaW9saW5lQ2FwdHVyZVByYWN0aW9uZXIiLCJkaXNwbGF5IjoiUkRUIFJlc3VsdCBVc2VyIiwic3lzdGVtIjoiaHR0cDovL2xvaW5jLm9yZyJ9XX0sInJlc291cmNlVHlwZSI6Ik9ic2VydmF0aW9uIiwic3RhdHVzIjoicmVxdWVzdGVkIiwidmFsdWVDb2RlYWJsZUNvbmNlcHQiOnsidGV4dCI6InBvc2l0aXZlX3BmIn19fSx7InJlc291cmNlIjp7ImNvZGUiOnsiY29kaW5nIjpbeyJjb2RlIjoicmR0QmlvbGluZUNhcHR1cmVNYWNoaW5lVmlzaW9uIiwiZGlzcGxheSI6IlJEVCBNTCBSZXN1bHQiLCJzeXN0ZW0iOiJodHRwOi8vbG9pbmMub3JnIn1dfSwicmVzb3VyY2VUeXBlIjoiT2JzZXJ2YXRpb24iLCJzdGF0dXMiOiJyZXF1ZXN0ZWQiLCJ2YWx1ZUNvZGVhYmxlQ29uY2VwdCI6eyJ0ZXh0IjoibmVnYXRpdmUifX19LHsicmVzb3VyY2UiOnsiY29kZSI6eyJjb2RpbmciOlt7ImNvZGUiOiJyZHRUaW1lckNhcHR1cmUiLCJkaXNwbGF5IjoiUkRUIENhcHR1cmUgVGltZXN0YW1wIiwic3lzdGVtIjoiaHR0cDovL2xvaW5jLm9yZyJ9XX0sInJlc291cmNlVHlwZSI6Ik9ic2VydmF0aW9uIiwic3RhdHVzIjoicmVxdWVzdGVkIiwidmFsdWVEYXRlVGltZSI6IjIwMjAtMDYtMDlUMTU6Mjg6NTEuODUzWiJ9fV19`)
        },

        beforeMount() {
            if (this.active) {
                this.elapsed = Date.now() - this.timer.timer_start
                this.setElapsedTime()
                this.interval = setInterval(this.setElapsedTime, 1000)
            }
        },

        methods: {
            async retake() {
                await this.$store.dispatch('v4/rdt/reset')
                await this.reset('rdt_test_id')
                this.toTrackPanel('rdt_test_id')
            },

            async start() {
                this.startTimer()
                this.setElapsedTime()
                this.interval = setInterval(this.setElapsedTime, 1000)
            },

            async skip() {
                await this.skipTest()
                this.next()
            },

            simulate() {
                this.$router.push(`/track/${this.$route.params.tracks_id}/observation/?fhirBundle=eyJyZXNvdXJjZVR5cGUiOiJCdW5kbGUiLCJ0eXBlIjoiYmF0Y2giLCJlbnRyeSI6W3sicmVzb3VyY2UiOnsiY29kZSI6eyJjb2RpbmciOlt7ImNvZGUiOiJyZHRCaW9saW5lQ2FwdHVyZVByYWN0aXRpb25lciIsImRpc3BsYXkiOiJSRFQgUmVzdWx0IFVzZXIiLCJzeXN0ZW0iOiJodHRwOi8vbG9pbmMub3JnIn1dfSwicmVzb3VyY2VUeXBlIjoiT2JzZXJ2YXRpb24iLCJzdGF0dXMiOiJyZXF1ZXN0ZWQiLCJ2YWx1ZUNvZGVhYmxlQ29uY2VwdCI6eyJ0ZXh0IjoicG9zaXRpdmVfcGYifX19LHsicmVzb3VyY2UiOnsiY29kZSI6eyJjb2RpbmciOlt7ImNvZGUiOiJyZHRCaW9saW5lQ2FwdHVyZU1hY2hpbmVWaXNpb24iLCJkaXNwbGF5IjoiUkRUIE1MIFJlc3VsdCIsInN5c3RlbSI6Imh0dHA6Ly9sb2luYy5vcmcifV19LCJyZXNvdXJjZVR5cGUiOiJPYnNlcnZhdGlvbiIsInN0YXR1cyI6InJlcXVlc3RlZCIsInZhbHVlQ29kZWFibGVDb25jZXB0Ijp7InRleHQiOiJuZWdhdGl2ZSJ9fX0seyJyZXNvdXJjZSI6eyJjb2RlIjp7ImNvZGluZyI6W3siY29kZSI6InJkdFRpbWVyQ2FwdHVyZSIsImRpc3BsYXkiOiJSRFQgQ2FwdHVyZSBUaW1lc3RhbXAiLCJzeXN0ZW0iOiJodHRwOi8vbG9pbmMub3JnIn1dfSwicmVzb3VyY2VUeXBlIjoiT2JzZXJ2YXRpb24iLCJzdGF0dXMiOiJyZXF1ZXN0ZWQiLCJ2YWx1ZURhdGVUaW1lIjoiMjAyMC0wNi0wOVQxNToyODo1MS44NTNaIn19XX0`)
            },

            ...mapActions({
                startTimer: 'v4/rdt/startTimer',
                skipTest: 'v4/rdt/skip',
                next: 'v4/navigate/next',
                toTrackPanel: 'v4/navigate/to',
                reset: 'v4/panel/reset',
            }),

            setElapsedTime() {

                if (this.elapsed > this.timer.timeout && this.timer.status !== 'captured') {
                    this.$store.dispatch('v4/rdt/endTimer')
                    clearInterval(this.interval)
                }
                else if (this.elapsed > this.timer.aquire) {
                    if (this.timer.beep) this.beep(this.sound)
                    this.$store.commit('v4/rdt/set', { status: 'aquiring', beep: false })
                }
                else
                    this.$store.commit('v4/rdt/set', { status: 'waiting' })

                this.elapsed = Date.now() - this.timer.timer_start
            },

            beep(fn) {
                let callCount = 0
                this.repeater = setInterval(function() {
                    if (callCount < 5) {
                        fn()
                        callCount += 1;
                    }
                    else {
                        clearInterval(this.repeater);
                    }
                }, 1000)
            },
            sound() {
                var snd = new Audio("data:audio/wav;base64,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");
                snd.play();
            }

        },
        destroyed() {
            clearInterval(this.repeater)
            clearInterval(this.interval)
        }
    }
</script>
